var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { filterAtom, searchQueryAtom } from '@/screens/SearchScreen/atoms';
import { updateSearchCacheForPlaceAsync } from '@/utils/SearchPlacesUtils';
import ToastUtils from '@/utils/ToastUtils';
import useAppComponents from './useAppComponents';
export function useToggleFavoritePlace() {
    const { api } = useAppComponents();
    const queryClient = useQueryClient();
    const { text, location } = useAtomValue(searchQueryAtom);
    const { sortOption, scoreUnder, hasSlope, isRegistered } = useAtomValue(filterAtom);
    const { mutate, isPending } = useMutation({
        mutationFn: (_a) => __awaiter(this, [_a], void 0, function* ({ currentIsFavorite, placeId, }) {
            if (currentIsFavorite) {
                return yield api.deletePlaceFavoritePost({ placeId });
            }
            else {
                return yield api.createPlaceFavoritePost({ placeId });
            }
        }),
        onMutate: (variables) => __awaiter(this, void 0, void 0, function* () {
            if (variables.searchQueryKey === undefined) {
                return;
            }
            yield queryClient.cancelQueries({
                queryKey: variables.searchQueryKey,
            });
            const previousSearchData = queryClient.getQueryData(variables.searchQueryKey);
            queryClient.setQueryData(variables.searchQueryKey, oldData => {
                if (!oldData)
                    return oldData;
                return oldData.map(data => data.place.id === variables.placeId
                    ? Object.assign(Object.assign({}, data), { place: Object.assign(Object.assign({}, data.place), { isFavorite: !variables.currentIsFavorite }) }) : data);
            });
            return {
                previousSearchData,
            };
        }),
        onSuccess: (_data, variables) => {
            if (!variables.currentIsFavorite) {
                ToastUtils.show('[메뉴 → 저장한 장소]에서 확인 가능해요');
            }
            else {
                ToastUtils.show('[저장한 장소]에서 해제했어요');
            }
            queryClient.invalidateQueries({ queryKey: ['FavoritePlaces'] });
            queryClient.invalidateQueries({
                queryKey: ['PlaceDetailV2', variables.placeId],
            });
            // Asynchronously update search cache with full latest data
            updateSearchCacheForPlaceAsync(api, queryClient, variables.placeId);
        },
        onError: (error, variables, context) => {
            ToastUtils.showOnApiError(error);
            if ((context === null || context === void 0 ? void 0 : context.previousSearchData) &&
                variables.searchQueryKey !== undefined) {
                queryClient.setQueryData(variables.searchQueryKey, context.previousSearchData);
            }
        },
    });
    const safeMutate = (args) => {
        if (isPending)
            return;
        mutate(Object.assign(Object.assign({}, args), { searchQueryKey: [
                'search',
                { text, location, sortOption, scoreUnder, hasSlope, isRegistered },
            ] }));
    };
    return safeMutate;
}
